import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClientService } from './client/client.service';
import { ErrorHandlerService } from './error-handler/error-handler.service';
import { FilterService } from './filter/filter.service';
import { GoogleAnalyticsService } from './google-analytics/google-analaytics.service';
import { LanguageService } from './language/language.service';
import { MetaTagsService } from './meta-tags/meta-tags.service';
import { NotificationService } from './notification/notification.service';
import { QueryParamsService } from './query-params/query-params.service';
import { RestApiService } from './rest-api/rest-api.service';
import { SharedService } from './shared-service/shared.service';
import { StorageService } from './storage/storage.service';
import { TableService } from './table/table.service';
import { AuthService } from './auth/auth.service';
import { CurrencyService } from './currency/currency.service';

@NgModule({
  imports: [MatSnackBarModule, MatDialogModule],
  providers: [
    ClientService,
    ErrorHandlerService,
    GoogleAnalyticsService,
    NotificationService,
    QueryParamsService,
    RestApiService,
    SharedService,
    TableService,
    StorageService,
    MetaTagsService,
    FilterService,
    LanguageService,
    AuthService,
    CurrencyService,
  ],
})
export class AppServices {}
